<svg width="131" height="131" viewBox="0 0 131 131" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M103.299 129.016L27.0846 129.185C23.1773 129.194 20.0052 126.029 20.0052 122.121L20.0052 36.0673L44.4537 36.0673C49.6552 36.0673 53.8719 31.8506 53.8719 26.6491L53.8719 2.20063L103.258 2.0252C107.169 2.0113 110.347 5.17787 110.347 9.08883L110.347 121.952C110.347 125.847 107.194 129.007 103.299 129.016Z"
    fill="#EBEBEB"
  />
  <path
    d="M20 36.0659L53.8667 2.19923L53.8667 31.3568C53.8667 33.9576 51.7584 36.0659 49.1576 36.0659L20 36.0659Z"
    fill="#CACACA"
  />
  <path
    d="M82.5792 77.0255L82.5792 72.2842L68.3552 72.2842L68.3552 58.0602L63.6139 58.0602L63.6139 72.2842L49.3899 72.2842L49.3899 77.0255L63.6139 77.0255L63.6139 91.2495L68.3552 91.2495L68.3552 77.0255L82.5792 77.0255Z"
    fill="#8C8C8C"
  />
</svg>
